/** UTM parameter capture and storage */

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

export function captureUTM() {
  const params = new URLSearchParams(window.location.search);
  const utm = {};
  let hasUTM = false;
  UTM_KEYS.forEach((key) => {
    const val = params.get(key);
    if (val) { utm[key] = val; hasUTM = true; }
  });
  if (hasUTM) {
    utm.landing_page = window.location.pathname;
    utm.referrer = document.referrer;
    sessionStorage.setItem("ng_utm", JSON.stringify(utm));
  }
}

export function getUTM() {
  try {
    const stored = sessionStorage.getItem("ng_utm");
    return stored ? JSON.parse(stored) : {};
  } catch { return {}; }
}
